import React, { useEffect, useRef } from "react";
import { BrowserQRCodeReader } from "@zxing/browser";

const QrScanner = ({ onClose, onScanSuccess }) => {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);

  useEffect(() => {
    const codeReader = new BrowserQRCodeReader();

    const startScanner = async () => {
      try {
        const controls = await codeReader.decodeFromVideoDevice(
          null,
          videoRef.current,
          (result) => {
            if (result) {
              onScanSuccess(result.getText());
              stopScanner();
            }
          }
        );
        controlsRef.current = controls;
      } catch (e) {
        console.error("QR Scanner error:", e);
      }
    };

    startScanner();
    return () => stopScanner();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stopScanner = () => {
    if (controlsRef.current) {
      controlsRef.current.stop();
      controlsRef.current = null;
    }
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "#000",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: 16,
          color: "#fff",
          fontWeight: 600,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2,
        }}
      >
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            stopScanner();
            onClose();
          }}
        >
          ✕ Close
        </span>
      </div>

      {/* Camera */}
      <video
        ref={videoRef}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain", // ✅ keeps camera normal, not zoomed
        }}
      />

      {/* Overlay with transparent cutout */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.6)",
          pointerEvents: "none",
        }}
      />

      {/* Transparent scan area */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: 250,
          height: 250,
          transform: "translate(-50%, -50%)",
          background: "transparent",
          zIndex: 1,
        }}
      >
        {/* 4 Corner Borders */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 40,
            height: 40,
            borderTop: "4px solid #00BFFF",
            borderLeft: "4px solid #00BFFF",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: 40,
            height: 40,
            borderTop: "4px solid #00BFFF",
            borderRight: "4px solid #00BFFF",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: 40,
            height: 40,
            borderBottom: "4px solid #00BFFF",
            borderLeft: "4px solid #00BFFF",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 40,
            height: 40,
            borderBottom: "4px solid #00BFFF",
            borderRight: "4px solid #00BFFF",
          }}
        />
      </div>
    </div>
  );
};

export default QrScanner;
